export default __webpack_public_path__ + "media/images/info-71607055fc693d1c833569da8522e027.png";